import React, { useEffect } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { ERouteLinks } from 'models/route';
import { Box, Grid, Tabs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { colors } from 'theme/colors';
import { ApplyOnlineCard } from 'pages/ApplyOnlinePage/ApplyOnlineCard';
import ApplicationStore from 'state/ApplicationStore';
import { ensureTwoDecimalPlaces } from 'helpers/number';
import { StyledTab } from './styles';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface IApplyCardData {
  id: string;
  title: string;
  description: string;
  numberOfFirearms: number;
  minimumAge: number;
  duration: number;
  fee: string;
  link: boolean;
  applyButtonLabel: string;
  applyModalTitle: string;
}

const ApplyCardsData: IApplyCardData[] = [
  {
    id: '00112233-4455-6677-8899-aabbccddeeff',
    title: 'Certificate to Possess a Firearm/s',
    description: 'Apply to possess a firearm certificate',
    numberOfFirearms: 1,
    minimumAge: 21,
    duration: 5,
    fee: ensureTwoDecimalPlaces(75),
    link: false,
    applyButtonLabel: 'Apply for a Firearm Certificate',
    applyModalTitle: 'Firearm Certificate guidance',
  },
  {
    id: '00112233-4455-6677-8899-aabbccddee00',
    title: 'Certificate to Possess a Shotgun',
    description: 'Apply to possess a shotgun certificate',
    numberOfFirearms: 1,
    minimumAge: 21,
    duration: 5,
    fee: ensureTwoDecimalPlaces(75),
    link: true,
    applyButtonLabel: 'Apply for a Shotgun Certificate',
    applyModalTitle: 'Shotgun Certificate guidance',
  },
];

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number) => ({
  id: `apply-tab-${index}`,
  'aria-controls': `apply-tab-panel-${index}`,
});

const ApplyOnlinePage = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    ApplicationStore.resetApplicationState();
  }, []);

  return (
    <>
      <Breadcrumbs
        items={[{ label: 'My Applications', route: ERouteLinks.MyApplications }, 'Apply']}
      />
      <StyledPageTitle variant="h4">Apply</StyledPageTitle>
      <Typography variant="body2">
        Please, choose the proper application form. After sending your application, you can
        verify the progress on <Link to={ERouteLinks.MyApplications}>My applications</Link>{' '}
        page. What do you want to apply for?
      </Typography>

      <Box sx={{ width: '100%', marginTop: '20px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="application-tabs"
          >
            <StyledTab
              icon={<Icon type={EIconTypes.plusDir} color={colors.blue600} />}
              iconPosition="start"
              label="New Certificate"
              {...a11yProps(0)}
            />
            <StyledTab
              icon={<Icon type={EIconTypes.renew} color={colors.blue600} />}
              iconPosition="start"
              label="Renew Certificate"
              {...a11yProps(1)}
            />
            <StyledTab
              icon={<Icon type={EIconTypes.plusDir} color={colors.blue600} />}
              iconPosition="start"
              label="Vary Certificate"
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Grid container spacing={0} columnGap={1} alignItems="stretch">
            {ApplyCardsData.map((item) => (
              <Grid item xs={4} key={item.id}>
                <ApplyOnlineCard item={item} />
              </Grid>
            ))}
          </Grid>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          Renew Licence Panel
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          Amendments Panel
        </CustomTabPanel>
      </Box>
    </>
  );
};

export { ApplyOnlinePage };
